<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Planos da empresa {{empresa.name}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="formPlano()">Novo</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <b-table striped hover :busy="loading" :items="planos" :fields="fieldPlanos"
            show-empty emptyText="Não há planos cadastrados para empresa.">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
            </div>
              <template slot="[actions]" slot-scope="row">
                  <b-button
                variant="outline-primary"
                size="sm"
                @click="formPlano(row.item)"
              >
                <i class="fa fa-edit"></i>
              </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    title="Split Plano"
                    @click="formSplit(row.item)"
                >
                  <i class="fa fa-percent"></i>
                </b-button>
              </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    }
  },
  async created() {
    const responsePlans = await axios.get(`api/juridica/${this.empresa._id}/plans`);
    this.planos = responsePlans.data;
    this.loading = false;
  },
  watch:{
    async empresa() {
      const responsePlans = await axios.get(`api/juridica/${this.empresa._id}/plans`);
      this.planos = responsePlans.data;
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
      planos: [],
      fieldPlanos:[
        {key: 'name', label: 'Nome do Plano'},
        {key: 'price', label: 'Preço', formatter: value => value ? this.$options.filters.money(value) : ''},
        {key: 'valorTaxaAdesao', label: 'Taxa de Adesão', class: 'text-center',
        formatter: value => value ? this.$options.filters.money(value) : 'Não utiliza'},
        {key: 'tipoPlano', label: 'Forma de pagamento'},
        {key: 'actions', label: 'Ações', class: 'text-center'}
      ]
    };
  },
  methods: {
    formPlano(plano) {
        const query = {};
        query.empresa = this.empresa._id;
        if (plano) {
          query.id = plano._id;
        }
        this.$router.push({name: 'EmpresaPlanoForm', query});
    },
    formSplit(plano) {
      const query = {};
      query.empresa = this.empresa._id;
      if (plano) {
        query.id = plano._id;
      }
      this.$router.push({name: 'SplitPlano', query});
    }
  }
};
</script>
